import { get } from 'lodash';
import getAppUrlBase from 'utils/getAppUrlBase';
import { mapDateFromApiModel } from './dateDataMapper';

export const mapRawSurveyListItemFromApiModel = (
  {
    relationships,
    id,
    attributes,
    attributes: {
      has_items: hasItems,
      answered_response_count: responseCount,
      slug,
      is_favorite: isFavorite,
      show_in_menu: showInMenu,
    },
  },
  included,
) => {
  const updaterData = included.find((element) => element.id === relationships.updater.data.id);
  const previewImageData = included.find((item) => get(item, 'id') === get(relationships, 'preview.data.id'));
  const { url: previewImgSrc } = get(previewImageData, 'attributes', {});
  const { first_name: firstName, last_name: lastName } = get(updaterData, 'attributes', {});

  return {
    id,
    ...attributes,
    hasItems,
    responseCount,
    isFavorite,
    showInMenu: showInMenu || false,
    previewImgSrc,
    surveyUrl: getAppUrlBase() + slug,
    createDate: mapDateFromApiModel(attributes.created_at),
    updateDate: mapDateFromApiModel(attributes.updated_at),
    updatedBy: `${firstName} ${lastName}`,
  };
};

export const mapSurveyListItemFromApiModel = ({ data, included }) =>
  mapRawSurveyListItemFromApiModel(data, included);
